import React, { useEffect, useState } from "react";
import axios from "axios";
import FRONTEND_CONFIG from "./frontend_config";

const AssignedStudents = () => {
  const [students, setStudents] = useState([]);

  // Fetch assigned students
  const fetchAssigned = async () => {
    try {
      const res = await axios.get(`${FRONTEND_CONFIG.API_URL}/api/questionset/assigned/list`);
      setStudents(res.data);
    } catch (error) {
      console.error("Error fetching assigned students", error);
    }
  };

  useEffect(() => {
    fetchAssigned();
  }, []);

  return (
    <div style={{ padding: "40px", fontFamily: "Arial, sans-serif" }}>
      <h2 style={{ textAlign: "center", marginBottom: "30px", color: "#333" }}>
        Assigned Students & Their Question Sets
      </h2>

      <div style={{ overflowX: "auto" }}>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          }}
        >
          <thead style={{ backgroundColor: "#007bff", color: "#fff" }}>
            <tr>
              <th style={{ padding: "12px 15px", textAlign: "left" }}>Application ID</th>
              <th style={{ padding: "12px 15px", textAlign: "left" }}>Name</th>
              <th style={{ padding: "12px 15px", textAlign: "left" }}>Email</th>
              <th style={{ padding: "12px 15px", textAlign: "left" }}>Assigned Question Set</th>
            </tr>
          </thead>

          <tbody>
            {students.length === 0 ? (
              <tr>
                <td colSpan="4" style={{ textAlign: "center", padding: "20px", color: "#555" }}>
                  No students found
                </td>
              </tr>
            ) : (
              students.map((s, index) => (
                <tr
                  key={s._id}
                  style={{
                    backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#fff",
                  }}
                >
                  <td style={{ padding: "12px 15px" }}>{s.applicationId}</td>
                  <td style={{ padding: "12px 15px" }}>{s.studentName}</td>
                  <td style={{ padding: "12px 15px" }}>{s.email}</td>
                  <td style={{ padding: "12px 15px" }}>
                    {s.assignedQuestionSet?.questionSetName || "Not Assigned"}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AssignedStudents;
